import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { yupErrorMsg } from '../../../../components/atoms/const';
import api from '../../../../components/api';

function useAddWarehouse() {
  const { id } = useParams();
  const navigation = useNavigate();
  const navigateToLanding = () => navigation('/warehouse');

  const { data: stateRes, isLoading: stateLoad } = useQuery(
    ['getAllStates', 'clients'],
    () => api.clients.getAllStates(),
  );
  const stateList = React.useMemo(() => {
    const resData = stateRes?.data?.data;
    if (resData) {
      return resData.map((x) => ({
        value: x.state,
        label: x.state,
      }));
    }
    return [];
  }, [stateRes]);

  const { mutate: addWarehouse, isLoading: addLoad } = useMutation(api.warehouse.add, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      navigateToLanding();
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });

  const { mutate: updateWarehouse, isLoading: updateLoad } = useMutation(api.warehouse.update, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      navigateToLanding();
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });

  const yupSchema = yup.object({
    name: yup.string().required(yupErrorMsg.NAME_EMPTY),
    streetAddress: yup.string().required(yupErrorMsg.STREET_ADDRESS_EMPTY),
    zipCode: yup.string().max(5, yupErrorMsg.ZIP_CODE_INCORRECT_FORMAT).min(5, yupErrorMsg.ZIP_CODE_INCORRECT_FORMAT).required(yupErrorMsg.ZIP_CODE_EMPTY),
    city: yup.string().required(yupErrorMsg.CITY_EMPTY),
    state: yup.string().required(yupErrorMsg.STATE_EMPTY),
  });
  const formik = useFormik({
    initialValues: {
      name: '',
      streetAddress: '',
      zipCode: '',
      city: '',
      state: '',
    },
    validationSchema: yupSchema,
    onSubmit: (values) => {
      const data = {
        name: values.name,
        addressTheSame: false,
        address: {
          streetAddress: values.streetAddress,
          zipCode: values.zipCode,
          city: values.city,
          state: values.state,
        },
      };
      if (!id) return addWarehouse(data);
      return updateWarehouse({ ...data, id: parseInt(id, 10) });
    },
  });

  const { data: warehouseRes, isLoading: warehouseLoad } = useQuery(
    ['getAll', 'warehouse'],
    () => api.warehouse.getAll(),
    { enabled: !!id },
  );

  const warehouseById = React.useMemo(() => {
    if (warehouseRes && id) {
      return warehouseRes?.data?.data?.find((x) => x.id.toString() === id);
    }
    return undefined;
  }, [warehouseRes, id]);

  React.useEffect(() => {
    if (warehouseById) {
      formik.setFieldValue('name', warehouseById.name ?? '');
      formik.setFieldValue('streetAddress', warehouseById.address?.streetAddress ?? '');
      formik.setFieldValue('city', warehouseById.address?.city ?? '');
      formik.setFieldValue('zipCode', warehouseById.address?.zipCode ?? '');
      formik.setFieldValue('state', warehouseById.address?.state ?? '');
    }
  }, [warehouseById]);

  const [isEdit, setIsEdit] = React.useState<boolean>(false);

  return {
    state: {
      list: stateList,
      load: stateLoad,
    },
    formik,
    warehouse: {
      load: warehouseLoad,
      data: warehouseById,
      id,
    },
    isEdit: {
      current: isEdit,
      setCurrent: setIsEdit,
    },
    submitLoad: updateLoad || addLoad,
  };
}

export default useAddWarehouse;
